/*
  Loading module used for code splitting
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './Loading.css';

class Loading extends Component {
  static propTypes = {
    spinnerSrc: PropTypes.string.isRequired,
  }

  render() {
    return (
      <div className={styles.relative}>
        <img className={styles.center} src={this.props.spinnerSrc} alt="center" />
      </div>
    );
  }
}
export default Loading;



// WEBPACK FOOTER //
// ./src/reactjs/shared/components/Loading/Loading.jsx